(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[345],{

/***/ 3544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product",
      function () {
        return __webpack_require__(6101);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fm": function() { return /* binding */ transformPriceToNumber; },
/* harmony export */   "zF": function() { return /* binding */ transformPrice; }
/* harmony export */ });
/* unused harmony export formatPrice */
var transformPrice = function(price, locale, currency) {
    var value = typeof price === "number" ? price / 100 : 0;
    try {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0
        }).format(value);
    } catch (e) {
        // Support pour les vieux navigateurs
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "symbol",
            minimumFractionDigits: 0
        }).format(value);
    }
};
var transformPriceToNumber = function(price) {
    var value = typeof price === "number" ? price / 100 : 0;
    return value.toFixed(2);
};
var formatPrice = function(value, locale, currency) {
    try {
        return Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "narrowSymbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(value);
    } catch (e) {
        // Support pour les vieux navigateurs
        return Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency !== null && currency !== void 0 ? currency : "eur",
            currencyDisplay: "symbol",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }).format(value);
    }
};


/***/ }),

/***/ 3415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mf": function() { return /* reexport */ ModalImageComponent; },
  "U8": function() { return /* reexport */ ProductCarouselComponent; }
});

// UNUSED EXPORTS: CloseComponent

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(4364);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(619);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(4658);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./components/external/close/close-component.module.scss
var close_component_module = __webpack_require__(2369);
var close_component_module_default = /*#__PURE__*/__webpack_require__.n(close_component_module);
;// CONCATENATED MODULE: ./components/external/close/close-component.tsx






var iconClose = "https://site.appchoose.io/external/icons/ic-close-white.svg";
var CloseComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CloseComponent, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(CloseComponent);
    function CloseComponent() {
        (0,_class_call_check/* default */.Z)(this, CloseComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.onClose = function() {
            _this.props.onClose();
        };
        return _this;
    }
    var _proto = CloseComponent.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((close_component_module_default()).close, " animated fadeIn"),
            onClick: this.onClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "close",
                src: iconClose
            })
        });
    };
    return CloseComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(1151);
// EXTERNAL MODULE: ./components/external/modal-image/modal-image-component.module.scss
var modal_image_component_module = __webpack_require__(4586);
var modal_image_component_module_default = /*#__PURE__*/__webpack_require__.n(modal_image_component_module);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(5350);
// EXTERNAL MODULE: ./utils/agent.ts + 1 modules
var agent = __webpack_require__(9754);
;// CONCATENATED MODULE: ./components/external/modal-image/modal-image-component.tsx







// import LazyImage from "../../lazy-image/lazy-image";


var icon = "https://site.appchoose.io/external/icons/ic-close-black.svg";
var ModalImageComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ModalImageComponent, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ModalImageComponent);
    function ModalImageComponent() {
        (0,_class_call_check/* default */.Z)(this, ModalImageComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.focused = _this.props.focusOn || 0;
        _this.state = {
            userAgent: {}
        };
        _this.focusOnImg = function() {
            var imgs = _this.ref.querySelectorAll("img");
            var elt = imgs[_this.focused];
            if (elt && typeof elt.scrollIntoView === "function") {
                elt.scrollIntoView({
                    block: "center"
                });
            }
        };
        _this.onPressKeyDown = function(event) {
            switch(event.keyCode){
                case 27:
                    if (typeof _this.props.onClose === "function") {
                        _this.props.onClose();
                    }
                    break;
                case 40:
                case 39:
                    event.preventDefault();
                    _this.focused = _this.focused >= _this.props.images.length - 1 ? _this.props.images.length - 1 : _this.focused + 1;
                    _this.focusOnImg();
                    break;
                case 38:
                case 37:
                    event.preventDefault();
                    _this.focused = _this.focused <= 0 ? 0 : _this.focused - 1;
                    _this.focusOnImg();
                    break;
                default:
                    break;
            }
        };
        _this.onClose = function() {
            if (typeof _this.props.onClose === "function") {
                _this.props.onClose();
            }
        };
        _this.onClickImage = function(event) {
            event.stopPropagation();
        };
        _this.onLoad = function() {
            _this.focusOnImg();
        };
        return _this;
    }
    var _proto = ModalImageComponent.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.focusOnImg();
        var userAgent = (0,agent/* getUserAgent */.i)();
        this.setState({
            userAgent: userAgent
        });
        document.addEventListener("keydown", this.onPressKeyDown);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.onPressKeyDown);
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (modal_image_component_module_default()).modal,
            onClick: this.onClose,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (modal_image_component_module_default()).close,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "close",
                        src: icon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: function(c) {
                        if (c) {
                            _this.ref = c;
                        }
                    },
                    className: "container ".concat((modal_image_component_module_default()).image),
                    onLoad: this.onLoad,
                    children: this.renderImages
                })
            ]
        });
    };
    (0,_create_class/* default */.Z)(ModalImageComponent, [
        {
            key: "renderImages",
            get: function get() {
                var _this = this;
                return this.props.images.map(function(image, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: _this.props.imageClassName,
                        onClick: _this.onClickImage,
                        src: (0,utils_image/* transformImage */.W)(image, "1500x", undefined, _this.state.userAgent.hasWebp),
                        alt: "Image produit"
                    }, "".concat(image, "-").concat(idx));
                });
            }
        }
    ]);
    return ModalImageComponent;
}(react.PureComponent);


// EXTERNAL MODULE: ./components/external/product-carousel/product-carousel-component.module.scss
var product_carousel_component_module = __webpack_require__(4955);
var product_carousel_component_module_default = /*#__PURE__*/__webpack_require__.n(product_carousel_component_module);
// EXTERNAL MODULE: ../node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(4837);
;// CONCATENATED MODULE: ./components/external/product-carousel/product-carousel-component.tsx









var ProductImages = /*#__PURE__*/ react.memo(function ProductImages(param) {
    var images = param.images, onClickItem = param.onClickItem;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
        className: (product_carousel_component_module_default()).carousel,
        onClickItem: onClickItem,
        showArrows: false,
        showStatus: false,
        autoPlay: false,
        showThumbs: false,
        swipeable: true,
        children: images && images.length > 1 ? images.map(function(image, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                alt: "product image ".concat(index),
                // , ${ transformImage(image.image, '1557x1557', undefined, userAgent.hasWebp).replace('full-fit-in/', '') } 3x
                srcSet: "".concat((0,utils_image/* transformImage */.W)(image.url, "1038x1038").replace("full-fit-in/", ""), " 2x"),
                src: (0,utils_image/* transformImage */.W)(image.url, "671x671").replace("full-fit-in/", "")
            }, index);
        }) : null
    });
});
var ProductCarouselComponent = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ProductCarouselComponent, _PureComponent);
    var _super = (0,_create_super/* default */.Z)(ProductCarouselComponent);
    function ProductCarouselComponent() {
        (0,_class_call_check/* default */.Z)(this, ProductCarouselComponent);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            selected: (0,utils_image/* transformImage */.W)(Array.isArray(_this.props.images) && _this.props.images[0] ? _this.props.images[0].url : "", "519x519", undefined, false).replace("full-fit-in/", "")
        };
        _this.onChangeImage = function(idxSelected) {
            if (_this.props.images) {
                _this.setState({
                    selected: (0,utils_image/* transformImage */.W)(_this.props.images[idxSelected].url, "519x519").replace("full-fit-in/", "")
                });
            }
        };
        _this.onSelect = function(idxSelected) {
            if (typeof _this.props.onSelect === "function") {
                _this.props.onSelect(idxSelected);
            }
            _this.onChangeImage(idxSelected);
        };
        _this.onClickItem = function(idxSelected) {
            _this.props.onClickModal(idxSelected);
        };
        _this.getClassName = function(index) {
            if (_this.props.idxSelected === index) {
                return (product_carousel_component_module_default()).active + " image-container";
            }
            return "image-container";
        };
        _this.onClickImage = function() {
            _this.props.onClickModal();
        };
        return _this;
    }
    var _proto = ProductCarouselComponent.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: this.getClassNameContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "".concat((product_carousel_component_module_default()).sidebar, " col-md-2 col-sm-0 col-2"),
                    children: this.props.images && this.props.images.length > 1 ? this.props.images.map(function(image, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: _this.getClassName(index),
                            onClick: _this.onSelect.bind(_this, index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "sm_image ".concat(index),
                                onClick: _this.onSelect.bind(_this, index),
                                src: (0,utils_image/* transformImage */.W)(image.url, "85x85").replace("full-fit-in/", ""),
                                srcSet: "".concat((0,utils_image/* transformImage */.W)(image.url, "170x170").replace("full-fit-in/", ""), " 2x, ").concat((0,utils_image/* transformImage */.W)(image.url, "255x255").replace("full-fit-in/", ""), " 3x")
                            })
                        }, index);
                    }) : null
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "col-md-10 ".concat(this.props.images && this.props.images.length === 1 ? "col-12" : "col-10", " col-sm-12"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "image selected",
                            // , ${this.state.selected.replace('519x519', '1557x1557')} 3x
                            srcSet: "".concat(this.state.selected.replace("519x519", "1038x1038"), " 2x"),
                            src: this.state.selected,
                            onClick: this.onClickImage
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImages, {
                    images: this.props.images,
                    onClickItem: this.onClickItem
                })
            ]
        });
    };
    (0,_create_class/* default */.Z)(ProductCarouselComponent, [
        {
            key: "getClassNameContainer",
            get: function get() {
                var text = (product_carousel_component_module_default()).product + " col-6 col-sm-12 col-md-12";
                if (this.props.className) {
                    text += " " + this.props.className;
                }
                if (this.props.images && this.props.images.length === 1) {
                    text += " " + (product_carousel_component_module_default()).single;
                }
                return text;
            }
        }
    ]);
    return ProductCarouselComponent;
}(react.PureComponent);


;// CONCATENATED MODULE: ./components/external/index.ts






/***/ }),

/***/ 8205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6528);
/* harmony import */ var _Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3496);





function KeysNewComponent() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("keys").t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container align-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: "".concat((_Keys_module_scss__WEBPACK_IMPORTED_MODULE_4___default().keys), " row"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "delivery",
                            srcSet: "https://public.choose.app/website/2023/Delivery@2x.png 2x,https://public.choose.app/website/2023/Delivery@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Delivery.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("delivery")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Notifications@2x.png 2x,https://public.choose.app/website/2023/Notifications@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Notifications.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("retour")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/Paiement@2x.png 2x,https://public.choose.app/website/2023/Paiement@3x.png 3x",
                            src: "https://public.choose.app/website/2023/Paiement.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("payment")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "col-sm-6 col-3 col-md-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            height: "104",
                            width: "104",
                            alt: "Notifications",
                            srcSet: "https://public.choose.app/website/2023/ServiceClient@2x.png 2x,https://public.choose.app/website/2023/ServiceClient@3x.png 3x",
                            src: "https://public.choose.app/website/2023/ServiceClient.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("support")
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (KeysNewComponent);


/***/ }),

/***/ 2971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2050);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _App_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(575);
/* harmony import */ var _App_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_App_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3496);
/* harmony import */ var _utils_agent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9754);
/* harmony import */ var _utils_lang__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3703);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1936);









function AppNewComponent(props) {
    var onClickApple = function onClickApple() {
        (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .trackEventSegment */ .P)("clickApple");
    };
    var onclickAndroid = function onclickAndroid() {
        (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .trackEventSegment */ .P)("clickAndroid");
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({}), 2), userAgent = ref[0], setUserAgent = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var ua = (0,_utils_agent__WEBPACK_IMPORTED_MODULE_4__/* .getUserAgent */ .i)();
        setUserAgent(ua);
    }, []);
    var ref1 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common"), t = ref1.t, i18n = ref1.i18n;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().app), " ").concat(props.className || ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("app")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().stores),
                            children: [
                                userAgent.isMobile && !userAgent.isAndroid || !userAgent.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noreferrer",
                                            onClick: onClickApple,
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().big), " plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=app"),
                                            title: "Apple Store",
                                            href: "https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                width: "182",
                                                height: "54",
                                                alt: "Apple Store",
                                                src: "https://public.choose.app/website/new/images/btn-big-app-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().small), " plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=app"),
                                            onClick: onClickApple,
                                            title: "Apple Store",
                                            href: "https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                width: "134",
                                                height: "40",
                                                alt: "Apple Store",
                                                src: "https://public.choose.app/website/new/images/btn-small-app-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        })
                                    ]
                                }) : null,
                                userAgent.isMobile && userAgent.isAndroid || !userAgent.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: onclickAndroid,
                                            href: "https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR",
                                            rel: "noreferrer",
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().big), " plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=app"),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                width: "182",
                                                height: "54",
                                                alt: "Play Store",
                                                src: "https://public.choose.app/website/new/images/btn-big-play-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: onclickAndroid,
                                            href: "https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR",
                                            rel: "noreferrer",
                                            className: "".concat((_App_module_scss__WEBPACK_IMPORTED_MODULE_7___default().small), " plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=app"),
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                height: "41",
                                                width: "136",
                                                alt: "Play Store",
                                                src: "https://public.choose.app/website/new/images/btn-small-play-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(i18n), ".svg")
                                            })
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    width: "177",
                    height: "177",
                    alt: "HeartRotate",
                    src: "https://public.choose.app/website/new/images/HeartRotate.png",
                    srcSet: "https://public.choose.app/website/new/images/HeartRotate@2x.png 2x,https://public.choose.app/website/new/images/HeartRotate@3x.png 3x"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AppNewComponent);


/***/ }),

/***/ 6101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3842);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(4364);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(1151);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(619);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4658);
/* harmony import */ var _Users_thibaut_CODES_react_appchoose_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5230);
/* harmony import */ var _Users_thibaut_CODES_react_appchoose_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_thibaut_CODES_react_appchoose_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(6002);
/* harmony import */ var _styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(2251);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5350);
/* harmony import */ var _components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6514);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1936);
/* harmony import */ var _api_currency__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(5283);
/* harmony import */ var _new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5374);
/* harmony import */ var _new_components_header_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5365);
/* harmony import */ var _new_components_sale_App_App__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2971);
/* harmony import */ var _new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8205);
/* harmony import */ var _components_external__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3415);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6511);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3496);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1340);
/* harmony import */ var _utils_lang__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(3703);








// import "../styles/pages/sale.scss"















var extraData = {};
var ProductScreen = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(ProductScreen, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(ProductScreen);
    function ProductScreen() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(this, ProductScreen);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            selectedImageId: 0,
            displayModal: false
        };
        _this.getTrad = function(str) {
            return _this.props.t(str);
        };
        _this.onModalClick = function() {
            _this.setState({
                displayModal: !_this.state.displayModal
            });
        };
        _this.onImageSelect = function(selectedImageId) {
            _this.setState({
                selectedImageId: selectedImageId
            });
        };
        return _this;
    }
    var _proto = ProductScreen.prototype;
    // tslint:disable-next-line:cognitive-complexity
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_Users_thibaut_CODES_react_appchoose_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _Users_thibaut_CODES_react_appchoose_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (_this.props.product) {
                            (0,_api__WEBPACK_IMPORTED_MODULE_16__/* .trackPage */ .K)("Product", {
                                id: _this.props.product.id
                            });
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    // tslint:disable-next-line:cognitive-complexity
    _proto.render = function render() {
        var _this = this;
        var ref, ref1;
        if (this.props.sale) {
            var ref2;
            extraData.saleId = (ref2 = this.props.sale) === null || ref2 === void 0 ? void 0 : ref2.key;
            extraData.itemId = this.props.product.key;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().sale),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_meta_header_meta_header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    pageTitle: this.getTitle,
                    canonical: _config__WEBPACK_IMPORTED_MODULE_18__/* .canonical */ .fK + "product/" + encodeURIComponent(this.props.product.url),
                    keywords: this.props.product.subtitle + "," + this.props.product.brand_name,
                    appleArguments: this.getAppleMeta,
                    isSquare: true,
                    description: this.getDescription.replace(/<b>/g, "").replace(/<\/b>/g, ""),
                    title: this.getTitle,
                    image: this.getMainImage,
                    noIndex: true
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_new_components_header_Header__WEBPACK_IMPORTED_MODULE_6__/* .HeaderNewComponent */ .w, {
                    showSlogan: true,
                    disableScroll: true,
                    hideBtns: true,
                    store: this.props.store,
                    language: this.props.i18n.language
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "container align-items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "row ".concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().sale_data), " ").concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().product_data)),
                            children: [
                                !this.state.displayModal ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_external__WEBPACK_IMPORTED_MODULE_9__/* .ModalImageComponent */ .Mf, {
                                    images: this.props.product.images.map(function(c) {
                                        return c.url;
                                    }),
                                    focusOn: this.state.selectedImageId,
                                    onClose: this.onModalClick
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_external__WEBPACK_IMPORTED_MODULE_9__/* .ProductCarouselComponent */ .U8, {
                                    images: this.props.product.images.slice(0, 4),
                                    onClickModal: this.onModalClick,
                                    className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().carousel),
                                    onSelect: this.onImageSelect,
                                    idxSelected: this.state.selectedImageId
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "col-sm-0 col-1 col-md-2 ".concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().separation))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "col-4 col-md-8 col-sm-12 ".concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().sale_info)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title_brand),
                                            children: this.props.product.title || this.props.product.brand_name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title_product),
                                            children: this.props.product.subtitle
                                        }),
                                        ((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.badges) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().badges),
                                            children: (ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.badges.map(function(badge) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().badge),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            height: "16",
                                                            width: "16",
                                                            disableWebp: true,
                                                            src: badge.image,
                                                            alt: badge.text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            children: _this.props.t(badge.code)
                                                        })
                                                    ]
                                                }, badge.text);
                                            })
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().pricesproduct),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().price_formatted),
                                                    children: (0,_api_currency__WEBPACK_IMPORTED_MODULE_19__/* .transformPrice */ .zF)(this.props.product.formatted_price, this.props.i18n.language || "fr", this.props.product.currency)
                                                }),
                                                this.props.product.price !== this.props.product.formatted_price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().price_normal),
                                                            children: (0,_api_currency__WEBPACK_IMPORTED_MODULE_19__/* .transformPrice */ .zF)(this.props.product.price, this.props.i18n.language || "fr", this.props.product.currency)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().discount),
                                                            children: [
                                                                "-",
                                                                this.props.product.discount,
                                                                "%"
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        this.props.product.eee_price ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().price_normal_eee),
                                            children: [
                                                this.props.t("ecopart"),
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                                                    children: (0,_api_currency__WEBPACK_IMPORTED_MODULE_19__/* .transformPrice */ .zF)(this.props.product.eee_price, this.props.i18n.language, this.props.product.currency)
                                                })
                                            ]
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().date),
                                            dangerouslySetInnerHTML: {
                                                __html: this.getText
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_new_components_sale_App_App__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().app)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "col-sm-0 col-1 col-md-2 ".concat((_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().separation))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr", {
                            className: (_styles_pages_sale_module_scss__WEBPACK_IMPORTED_MODULE_17___default().sale_hr)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_new_components_home_Keys_Keys__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_new_components_footer_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    store: this.props.store
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: this.setSchema
                })
            ]
        });
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(ProductScreen, [
        {
            key: "getTitle",
            get: function get() {
                if (this.props.product && this.props.sale) {
                    var ref;
                    return "".concat((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.name, " - ").concat(this.props.product.subtitle, "\xa0| ").concat(this.getTrad("sale_ongoing"));
                }
                return "";
            }
        },
        {
            key: "getDescription",
            get: function get() {
                var ref, ref1, ref2, ref3, ref4;
                if ((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.sale_ended) {
                    var ref5;
                    return "".concat((ref5 = this.props.sale) === null || ref5 === void 0 ? void 0 : ref5.name, " - ").concat(this.props.product.subtitle, " ").concat(this.getTrad("discover"), ". ").concat(this.getTrad("sale_delivery"));
                } else if ((ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.sale_started) {
                    var ref6, ref7, ref8;
                    return "".concat((ref6 = this.props.sale) === null || ref6 === void 0 ? void 0 : ref6.name, " - ").concat(this.props.product.subtitle, " ").concat(this.getTrad("discover"), " ").concat(this.getTrad("basic"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_21__/* .formatPublicHome */ .kC)((ref7 = this.props.sale) === null || ref7 === void 0 ? void 0 : ref7.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_22__/* .getLang */ .V)(this.props.i18n), ((ref8 = this.props.sale) === null || ref8 === void 0 ? void 0 : ref8.store) || "fr"), ". ").concat(this.getTrad("sale_delivery"));
                }
                return "".concat((ref2 = this.props.sale) === null || ref2 === void 0 ? void 0 : ref2.name, " - ").concat(this.props.product.subtitle, " ").concat(this.getTrad("discover"), " ").concat(this.getTrad("basic"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_21__/* .formatNextHome */ .Ec)((ref3 = this.props.sale) === null || ref3 === void 0 ? void 0 : ref3.start_at, (ref4 = this.props.sale) === null || ref4 === void 0 ? void 0 : ref4.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_22__/* .getLang */ .V)(this.props.i18n), this.props.sale.store), ". ").concat(this.getTrad("sale_delivery"));
            }
        },
        {
            key: "getMainImage",
            get: function get() {
                if (this.props.product && Array.isArray(this.props.product.images) && this.props.product.images[0]) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_23__/* .transformImage */ .W)(this.props.product.images[0].url, "750");
                // return `https://img.appchoose.io/unsafe/630x630/filters:watermark(https://public.choose.app/website/new/images/logo-${
                //   this.props.product.images[0].dark_color ? "white" : "black"
                // }.png,158,272,50)/prod/${
                //   this.props.product.images[0].url.split("/prod/")[1]
                // }`;
                }
            }
        },
        {
            key: "isAvailable",
            get: function get() {
                if (this.props.sale) {
                    var ref, ref1;
                    return !((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.sale_ended) && ((ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.sale_started) && !this.props.product.tester;
                }
                return undefined;
            }
        },
        {
            key: "getAppleMeta",
            get: function get() {
                if (this.props.product) {
                    var ref, ref1;
                    if (!((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.single_offer) && ((ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.url)) {
                        var ref2;
                        return "chooseapp://sales/".concat(encodeURIComponent((ref2 = this.props.sale) === null || ref2 === void 0 ? void 0 : ref2.url));
                    }
                    return "chooseapp://product/".concat(encodeURIComponent(this.props.product.url));
                }
            }
        },
        {
            key: "getAvailability",
            get: function get() {
                if (this.props.sale) {
                    var ref, ref1;
                    if ((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.sale_ended) {
                        return "https://schema.org/Discontinued";
                    } else if ((ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.sale_started) {
                        return this.props.product.stock !== 0 ? "http://schema.org/InStock" : "http://schema.org/OutOfStock";
                    }
                }
                return "https://schema.org/PreOrder";
            }
        },
        {
            key: "getGender",
            get: function get() {
                if (this.props.product) {
                    if (this.props.product.gender === 0) {
                        return "female";
                    } else if (this.props.product.gender === 1) {
                        return "male";
                    }
                    return "unisex";
                }
                return "unisex";
            }
        },
        {
            key: "setSchema",
            get: function get() {
                return {
                    __html: this.props.product ? '{"@context": "http://schema.org",\n                "@type": "Product",\n                "gender": "'.concat(this.getGender, '",\n                "age_group":"adult",\n                "offers": {\n                  "@type": "Offer",\n                  "itemCondition": "https://schema.org/NewCondition",\n                  "availability": "https://schema.org/InStock",\n                  "price":  ').concat((0,_api_currency__WEBPACK_IMPORTED_MODULE_19__/* .transformPriceToNumber */ .Fm)(this.props.product.formatted_price), ',\n                  "priceCurrency": "').concat(this.props.product.currency.toUpperCase(), '"\n                  },\n                  "description": "').concat(this.props.product.description.replace(/<b>/g, "").replace(/<\/b>/g, "").replace(/"/g, "").replace(/(\r\n|\n|\r)/gm, " "), '",\n                  "name": "').concat(this.props.product.subtitle.replace(/"/g, "").replace(/(\r\n|\n|\r)/gm, " "), '",\n                  "brand":"').concat((this.props.product.brand_name || this.props.product.title).replace(/"/g, "").replace(/(\r\n|\n|\r)/gm, " "), '",\n                  "gtin":"').concat(this.props.product.gtin || "", '",\n\n                    "image":"').concat(this.getMainImage, '",\n                 \n                  "url": "').concat(_config__WEBPACK_IMPORTED_MODULE_18__/* .canonical */ .fK, "product/").concat(encodeURIComponent(this.props.product.url), '"\n            }').replace(/\n/g, "") : ""
                };
            }
        },
        {
            key: "getText",
            get: function get() {
                var ref, ref1, ref2, ref3;
                if ((ref = this.props.sale) === null || ref === void 0 ? void 0 : ref.sale_ended) {
                    return this.getTrad("sale_ended");
                } else if ((ref1 = this.props.sale) === null || ref1 === void 0 ? void 0 : ref1.sale_started) {
                    var ref4;
                    return "".concat(this.getTrad("sale_ongoing"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_21__/* .formatPublicHome */ .kC)((ref4 = this.props.sale) === null || ref4 === void 0 ? void 0 : ref4.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_22__/* .getLang */ .V)(this.props.i18n), this.props.sale.store));
                }
                return "".concat(this.getTrad("sale_next"), " ").concat((0,_utils__WEBPACK_IMPORTED_MODULE_21__/* .formatNextHome */ .Ec)((ref2 = this.props.sale) === null || ref2 === void 0 ? void 0 : ref2.start_at, (ref3 = this.props.sale) === null || ref3 === void 0 ? void 0 : ref3.end_at, (0,_utils_lang__WEBPACK_IMPORTED_MODULE_22__/* .getLang */ .V)(this.props.i18n), this.props.sale.store));
            }
        }
    ]);
    return ProductScreen;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_i18next__WEBPACK_IMPORTED_MODULE_11__/* .withTranslation */ .Zh)("sale")((0,next_router__WEBPACK_IMPORTED_MODULE_3__.withRouter)(ProductScreen)));


/***/ }),

/***/ 2251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CI": function() { return /* binding */ formatBasic; },
/* harmony export */   "Ec": function() { return /* binding */ formatNextHome; },
/* harmony export */   "kC": function() { return /* binding */ formatPublicHome; }
/* harmony export */ });
/* unused harmony exports formatEnd, addDays, differenceInMinutes, differenceInHours, differenceInDays, isWeekend */
var formatEnd = function(endAt) {
    var d = new Date();
    var diff = differenceInDays(d, endAt);
    if (diff > 1) {
        return "".concat(diff, " jours restants");
    }
    var diffHours = differenceInHours(d, endAt);
    if (diffHours > 24) {
        return "1 jour restant";
    }
    if (diffHours > 1) {
        return "".concat(diffHours, "h restantes");
    }
    return "1h restante";
};
var formatBasic = function(endAt, lang, store) {
    var d = new Date(endAt);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    return d.toLocaleDateString(LOCALE, {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined
    });
};
var formatPublicHome = function(end_at, lang, store) {
    var endAt = new Date(end_at);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    var month = endAt.toLocaleDateString(LOCALE, {
        month: "long",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined,
        weekday: "short",
        day: "numeric",
        hour: store === "us" ? "numeric" : undefined
    });
    var diff = Math.abs(differenceInHours(new Date(), endAt));
    var res = "";
    if (diff <= 24) {
        res = lang === "fr" ? "jusqu'\xe0 demain" : "until tomorrow";
    } else if (diff <= 48) {
        res = lang === "fr" ? "jusqu'apr\xe8s-demain" : "until the day after tomorrow";
    } else {
        res = lang === "fr" ? "jusqu'au ".concat(month) : "until ".concat(month);
    }
    return "<b>" + res + "</b>";
};
var formatNextHome = function(start_at, end_at, lang, store) {
    var startAt = new Date(start_at);
    var endAt = new Date(end_at);
    var LOCALE = lang === "fr" ? "fr-FR" : "en";
    // const dayEnd = endAt.toLocaleDateString(LOCALE, { weekday: 'long' });
    var dayEnd = endAt.toLocaleDateString(LOCALE, {
        month: "long",
        timeZone: "UTC",
        timeZoneName: store === "us" ? "short" : undefined,
        weekday: "short",
        day: "numeric",
        hour: store === "us" ? "numeric" : undefined
    });
    var diff = differenceInHours(new Date(), startAt);
    var res = "";
    if (diff <= 24) {
        res = lang === "fr" ? "de demain au ".concat(dayEnd) : "from tomorrow to ".concat(dayEnd);
    } else if (diff <= 48) {
        res = lang === "fr" ? "d'apr\xe8s-demain au ".concat(dayEnd) : "from the day after tomorrow to ".concat(dayEnd);
    } else {
        var day = startAt.toLocaleDateString(LOCALE, {
            weekday: "long",
            day: "numeric",
            timeZone: "UTC"
        });
        res = lang === "fr" ? "du ".concat(day, " au ").concat(dayEnd) : "from ".concat(day, " to ").concat(dayEnd);
    }
    return "<b>" + res + "</b>";
};
var addDays = function(date, days) {
    return new Date(date.getTime() + days * 60000 * 24 * 60);
};
var differenceInMinutes = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60);
};
var differenceInHours = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60 / 60);
};
var differenceInDays = function(start, end) {
    var t1 = start.getTime();
    var t2 = end.getTime();
    return Math.floor((t2 - t1) / 1000 / 60 / 60 / 24);
};
var isWeekend = function(date) {
    var day = date.getDay();
    return day === 6 || day === 0;
};


/***/ }),

/***/ 5350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ transformImage; }
/* harmony export */ });
var transformImage = function(image, sizes, removeFit, _webP) {
    if (image) {
        image = image.replace(":format(webp)", "").replace("resize:fit", "resize:fill");
        if (removeFit) {
            image = image.replace("full-fit-in/", "").replace("fit-in/", "");
        }
        return image.replace("[W]x[H]/", sizes + "/");
    }
    return "";
};


/***/ }),

/***/ 2369:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"close":"close-component_close__Zl7nU"};

/***/ }),

/***/ 4586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-image-component_modal__A17ZC","image":"modal-image-component_image__z2qyg","lazy-image":"modal-image-component_lazy-image__Iyf_t","modal-image-component":"modal-image-component_modal-image-component__FZzni"};

/***/ }),

/***/ 4955:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product":"product-carousel-component_product__VVgT1","sidebar":"product-carousel-component_sidebar__7MRzs","active":"product-carousel-component_active__5BqNm","single":"product-carousel-component_single__T_pC7","carousel":"product-carousel-component_carousel__dcPh3"};

/***/ }),

/***/ 6528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"keys":"Keys_keys__HpzY5"};

/***/ }),

/***/ 575:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__tJ585","stores":"App_stores__NpcYj","small":"App_small__001jb","big":"App_big__6kFAu","content":"App_content__H7Y49","text":"App_text__NIw_B"};

/***/ }),

/***/ 6002:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sale":"sale_sale__wSg8c","prices":"sale_prices__qXF57","pricesproduct":"sale_pricesproduct__Tsnsi","discount":"sale_discount__1cslx","price_formatted":"sale_price_formatted__vsT2H","price_normal":"sale_price_normal__IJcnb","price_normal_eee":"sale_price_normal_eee__R6grx","tester":"sale_tester__IBTWH","sizes":"sale_sizes__Jmanb","margin":"sale_margin__wTO1F","hrlight":"sale_hrlight__vzcOJ","cguText":"sale_cguText__epXWa","cgu":"sale_cgu__i47Qt","sale_data":"sale_sale_data__2JMT9","product_data":"sale_product_data__0r9Vn","sale_info":"sale_sale_info__33qiu","stock":"sale_stock__dgg5M","breadcrump":"sale_breadcrump__UV1gL","products":"sale_products__ggtB8","badges":"sale_badges__S_adm","details":"sale_details__jLyR1","description":"sale_description__qyXGY","date":"sale_date___KEci","giveaway":"sale_giveaway__NumkQ","delivery":"sale_delivery__ok3rv","instagram":"sale_instagram__P7HLl","sale_hr":"sale_sale_hr__REAy7","badge":"sale_badge__07QCE","separation":"sale_separation__ZVKuY","carousel":"sale_carousel__Kp7TX","image":"sale_image__QP9WL","app":"sale_app__IyPAb","title_brand":"sale_title_brand__PBbHe","title_product":"sale_title_product__NutSy","category":"sale_category__vJSO9"};

/***/ }),

/***/ 6677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5817)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [195,837,530,975,774,888,179], function() { return __webpack_exec__(3544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);